import React from 'react';
import { Typography } from 'antd';
import { SYSTEMNAME } from '../appsettings';
import logo from '../../sitelogo.png';

const { Title, Text } = Typography;

const AuthLayout = ({ children, title, subtitle, extra }) => {
    return (
        <div style={{
            minHeight: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f7fa',
            position: 'relative',
            padding: '24px',
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
            overflow: 'hidden'
        }}>
            {/* Decorative circles */}
            <div style={{
                position: 'absolute',
                top: '-100px',
                right: '-80px',
                width: '350px',
                height: '350px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(32,156,150,0.08), rgba(32,156,150,0.02))',
                filter: 'blur(2px)'
            }} />
            <div style={{
                position: 'absolute',
                bottom: '-60px',
                left: '-60px',
                width: '250px',
                height: '250px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(32,156,150,0.06), rgba(32,156,150,0.01))',
                filter: 'blur(2px)'
            }} />

            <div style={{
                width: '100%',
                maxWidth: '420px',
                zIndex: 1,
                position: 'relative'
            }}>
                {/* Card */}
                <div style={{
                    background: '#ffffff',
                    borderRadius: '24px',
                    padding: 'clamp(28px, 5vw, 44px) clamp(24px, 4vw, 36px)',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.04)',
                    border: '1px solid rgba(0,0,0,0.04)'
                }}>
                    {/* Logo inside card */}
                    <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                        <img src={logo} alt="logo" style={{ height: 70 }} />
                    </div>

                    <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                        <Title 
                            level={3} 
                            style={{ 
                                color: '#1a1a2e', 
                                marginBottom: '8px', 
                                fontWeight: 700,
                                letterSpacing: '-0.5px',
                                fontSize: 'clamp(20px, 4vw, 26px)'
                            }}
                        >
                            {title}
                        </Title>
                        <Text style={{ color: '#8b949e', fontSize: 14, lineHeight: 1.5 }}>
                            {subtitle}
                        </Text>
                    </div>

                    {children}

                    {extra}
                </div>

                {/* Footer outside card */}
                <div style={{ textAlign: 'center', marginTop: '24px' }}>
                    <Text style={{ 
                        fontSize: '11px', 
                        color: '#b0b8c1',
                        letterSpacing: '0.3px'
                    }}>
                        © 2026 {SYSTEMNAME} • Powered by DSM
                    </Text>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
